// extracted by mini-css-extract-plugin
var _1 = "Checkbox_checkbox__JfSNC";
var _2 = "Checkbox_checkboxError__c3fH8";
var _3 = "Checkbox_size14__hhN+t";
var _4 = "Checkbox_size20__pz4pt";
export { _1 as "checkbox", _2 as "checkboxError", _3 as "size14", _4 as "size20" }
